import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';

const ProtectedRoute = ({ children, requireVerification = true }) => {
  const { isAuthenticated, isVerified } = useSelector((state) => state.auth);
  const location = useLocation();

  // If not authenticated, redirect to login
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // If authenticated but not verified and verification is required, redirect to verification
  if (requireVerification && !isVerified) {
    return <Navigate to="/verify-email" state={{ from: location }} replace />;
  }

  // If authenticated and verified (or verification not required), render children
  return children;
};

export default ProtectedRoute;
